import { useEffect, useState, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { chevronDownSvgTwo } from '../../assets/images';

interface FilterDropdownProps {
    options: any;
    label: string;
    labelKey: string;
    dropdownType: string;
    selectedValues: any;
    clearFilter: (labelKey: string, isMulti: boolean) => void;
    handleSelect: (filterLabel: any, option: any) => void;
    handleMultiSelect: (filterLabel: any, option: any) => void;
}

const FilterDropdown = (props: FilterDropdownProps) => {
    const { label, labelKey, selectedValues, handleMultiSelect, handleSelect, options, ...rest } =
        props;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<any>(null);
    const dropdownToggleRef = useRef<any>(null);
    const dropdownMenuRef = useRef<any>(null);
    const toggleDropdown = (isDDOpen: any) => {
        setIsOpen(isDDOpen);
    };

    // handle if click outside of drodown and toggle icon
    const handleClickOutside = (e: any) => {
        const dropdownCond =
            dropdownRef?.current &&
            !dropdownRef.current.contains(e.target) &&
            dropdownToggleRef?.current &&
            !dropdownToggleRef.current.contains(e.target);

        // check if click is outside od dropdown and toggle icon
        if (dropdownCond) {
            // close drodown on click outside
            setIsOpen(false);
        }
    };

    // handle esc key event
    const handleEscape = (event: any) => {
        if (event.key === 'Escape') {
            // close dropdown on esc key press
            setIsOpen(false);
        }
    };

    useEffect(() => {
        // event listener to check if click outside of component
        document.addEventListener('mousedown', handleClickOutside);
        // Escape key down event listener to close dropdown
        document.addEventListener('keydown', handleEscape);
        return () => {
            // remove the event listener
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropdownRef]);

    useEffect(() => {
        // This function will be called when the scroll event occurs
        const handleScroll = () => {
            // Close the dropdown by setting showDropdown to false
            setIsOpen(false);
        };

        // Add an event listener to the window object for the scroll event
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleOptionClick = (option: any) => {
        console.log(option, '***');
        if (rest?.dropdownType === 'Multi Select') {
            handleMultiSelect(labelKey, option);
        } else {
            handleSelect(labelKey, option);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>, option: string) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.currentTarget.click();
            handleOptionClick(option);
        }
    };

    const renderCheckbox = (option: any) => {
        return (
            <>
                <input
                    type="checkbox"
                    id={option}
                    checked={selectedValues[labelKey]?.some((o: any) => o.value === option.value)}
                    onChange={() => handleOptionClick(option)}
                    onKeyDown={(e) => handleKeyDown(e, option)}
                />
            </>
        );
    };

    const isSelected = (option: any, isSingleSelectDropdown: boolean) => {
        if (isSingleSelectDropdown) {
            return selectedValues[labelKey] === option.value;
        } else {
            return selectedValues[labelKey]?.some((o: any) => o.value === option.value);
        }
    };

    return (
        <>
            <Dropdown
                className="filter-dropdown"
                ref={dropdownRef}
                show={isOpen}
                onToggle={(isOpen) => {
                    toggleDropdown(isOpen);
                }}
            >
                <Dropdown.Toggle ref={dropdownToggleRef} aria-label={`label dropdown`}>
                    {rest?.dropdownType === 'Single Select' && selectedValues[labelKey] ? (
                        <>
                            <span className="placeholder">{label}</span>
                            <span className="value">
                                {selectedValues[labelKey]?.text}{' '}
                                <img
                                    className={'sort-img'}
                                    src={chevronDownSvgTwo}
                                    alt={`toggle`}
                                />
                            </span>
                        </>
                    ) : rest?.dropdownType === 'Multi Select' &&
                      selectedValues[labelKey]?.length > 0 ? (
                        <>
                            <span className="placeholder">{label}</span>
                            <span className="value">
                                {selectedValues[labelKey]?.length}{' '}
                                <img
                                    className={'sort-img'}
                                    src={chevronDownSvgTwo}
                                    alt={`toggle`}
                                />
                            </span>
                        </>
                    ) : (
                        <>
                            <span className="placeholder">{label}</span>
                            <span className="value">
                                All{' '}
                                <img
                                    className={'sort-img'}
                                    src={chevronDownSvgTwo}
                                    alt={`toggle`}
                                />
                            </span>
                        </>
                    )}
                </Dropdown.Toggle>
                <Dropdown.Menu
                    className={`${
                        rest?.dropdownType === 'Single Select' ? 'single-select' : 'multi-select'
                    }`}
                    ref={dropdownMenuRef}
                >
                    {options && options?.length > 0
                        ? options?.map((option: any) => (
                              <div
                                  key={option.value}
                                  className={`dropdown-item ${
                                      isSelected(option, rest?.dropdownType === 'Single Select')
                                          ? 'selected'
                                          : ''
                                  }`}
                                  onClick={(e) => {
                                      if (rest?.dropdownType === 'Single Select') {
                                          handleSelect(labelKey, option);
                                      } else {
                                          e.stopPropagation();
                                      }
                                  }}
                              >
                                  {rest?.dropdownType === 'Multi Select' && renderCheckbox(option)}
                                  <label
                                      className="dropdown-item-label"
                                      htmlFor={rest?.dropdownType === 'Multi Select' ? option : ''}
                                  >
                                      {option.text}
                                  </label>
                              </div>
                          ))
                        : ''}
                    <div
                        className={'clear-filters-dropdown'}
                        onClick={() =>
                            props.clearFilter(labelKey, rest?.dropdownType === 'Multi Select')
                        }
                    >
                        {`Clear Filters`}
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default FilterDropdown;
